import type { TElement } from '@udecode/plate';
import { useEditorPlugin, useEditorSelector } from '@udecode/plate/react';
import { useCallback } from 'react';

import { SourceCaptionPlugin } from '../SourceCaptionPlugin';

export const useSourceCaptionForElement = (element: TElement) => {
    const plugin = useEditorPlugin(SourceCaptionPlugin);

    const hasSource = useEditorSelector(e => (
        e.getPlugin(SourceCaptionPlugin).api.sourceCaption.isAbove(element) ||
        e.getPlugin(SourceCaptionPlugin).api.sourceCaption.isBelow(element)
    ), [element]);

    const insertSource = useCallback(() => {
        plugin.tf.insert.sourceCaption(element);
    }, [element, plugin]);

    const removeSource = useCallback(() => {
        plugin.tf.remove.sourceCaption(element);
    }, [element, plugin]);

    return { hasSource, insertSource, removeSource };
};
